import { render, staticRenderFns } from "./OsDetailsHistoryTable.vue?vue&type=template&id=54470c51"
import script from "./OsDetailsHistoryTable.vue?vue&type=script&lang=js"
export * from "./OsDetailsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports